import {
  Award,
  BadgeCheck,
  BookOpen,
  BookText,
  Bot,
  Building2,
  ClipboardCheck,
  Database,
  FileBarChart,
  Flame,
  FolderOpen,
  Gauge,
  MessagesSquare,
  Package,
  Percent,
  Recycle,
  ShoppingCart,
  ToggleRight,
  Trash2,
  UserCog,
  Users,
} from 'lucide-react';
import type { OffOrgNavSection } from '@/config/offOrgNavigation';

/**
 * The System Settings sidebar (super admin only; docs/NAVIGATION.md "Off-org
 * navigation"), shown by `AppLayout navigation="system"` on `/system-settings/*`.
 * System Settings is platform-wide and needs no organization, so it lives
 * outside `/org/:orgId` and every href is absolute. Every item sits under a
 * domain heading — add a page to an existing section, or a new section.
 */
export const SYSTEM_NAV_SECTIONS: OffOrgNavSection[] = [
  {
    headingKey: 'nav.systemSettings.headings.platform',
    items: [
      { labelKey: 'nav.systemSettings.users', href: '/system-settings/users', icon: Users },
      { labelKey: 'nav.systemSettings.featureFlags', href: '/system-settings/feature-flags', icon: ToggleRight },
      { labelKey: 'nav.systemSettings.bookkeeper', href: '/system-settings/bookkeeper', icon: Bot },
      { labelKey: 'nav.systemSettings.usage', href: '/system-settings/usage', icon: Gauge },
      { labelKey: 'nav.systemSettings.subscriptions', href: '/system-settings/subscriptions', icon: BadgeCheck },
    ],
  },
  {
    headingKey: 'nav.systemSettings.headings.accounting',
    items: [
      { labelKey: 'nav.systemSettings.coaTemplates', href: '/system-settings/coa-templates', icon: BookOpen },
      { labelKey: 'nav.systemSettings.taxRateTemplates', href: '/system-settings/tax-rate-templates', icon: Percent },
    ],
  },
  {
    headingKey: 'nav.systemSettings.headings.entityTypes',
    items: [
      { labelKey: 'nav.systemSettings.thingTypes', href: '/system-settings/asset-types', icon: Package },
      { labelKey: 'nav.systemSettings.projectTypes', href: '/system-settings/project-types', icon: FolderOpen },
      { labelKey: 'nav.systemSettings.businessTypes', href: '/system-settings/business-types', icon: Building2 },
      { labelKey: 'nav.systemSettings.interactionTypes', href: '/system-settings/interaction-types', icon: MessagesSquare },
      { labelKey: 'nav.systemSettings.interactionRoles', href: '/system-settings/interaction-roles', icon: UserCog },
    ],
  },
  {
    headingKey: 'nav.systemSettings.headings.materials',
    items: [
      { labelKey: 'nav.systemSettings.procurementTypes', href: '/system-settings/procurement-types', icon: ShoppingCart },
      { labelKey: 'nav.systemSettings.recycledContentTypes', href: '/system-settings/recycled-content-types', icon: Recycle },
      { labelKey: 'nav.systemSettings.endOfLifePlans', href: '/system-settings/end-of-life-plans', icon: Trash2 },
      { labelKey: 'nav.systemSettings.wasteTreatmentMethods', href: '/system-settings/waste-treatment-methods', icon: Flame },
    ],
  },
  {
    headingKey: 'nav.systemSettings.headings.sustainability',
    items: [
      { labelKey: 'nav.systemSettings.assessments', href: '/system-settings/assessments', icon: ClipboardCheck },
      { labelKey: 'nav.systemSettings.emissionFactors', href: '/system-settings/emission-factors', icon: Database },
      { labelKey: 'nav.systemSettings.bedes', href: '/system-settings/bedes', icon: BookText },
      { labelKey: 'nav.systemSettings.fundingOpportunities', href: '/system-settings/funding-opportunities', icon: Award },
    ],
  },
  {
    headingKey: 'nav.systemSettings.headings.audits',
    items: [
      { labelKey: 'nav.systemSettings.deletionAudit', href: '/system-settings/deletion-audit', icon: FileBarChart },
    ],
  },
];
